import { ENVS, PLATFORMS, BC_HOSTNAMES, CPA_HOSTNAMES, BIM360_HOSTNAMES, BIM360_EMEA_HOSTNAMES, OXYGEN_URL, USER_PROFILE_URL, ADMIN_API_URL, ADMIN_CONSTRUCTION_API_URL, BIM360_ADMIN_URL, RELATIONSHIP_API_URL, APIGEE_URL, REPORTS_V2_URL, FORMS_API_URL } from './envConsts';
import { parseAccUrl } from './parseAccUrl';
const getSafeEnvFromProcessEnv = () => {
  try {
    return process.env.REACT_APP_ACS_ENV;
  } catch (_unused) {
    return undefined;
  }
};
const getSafeRegionFromProcessEnv = () => {
  try {
    return process.env.REACT_APP_ACS_REGION;
  } catch (_unused2) {
    return undefined;
  }
};
function isBIM(currentHostname) {
  return currentHostname.includes(BIM360_HOSTNAMES[ENVS.QA]) || currentHostname.includes(BIM360_HOSTNAMES[ENVS.STAGING]) || currentHostname.includes(BIM360_EMEA_HOSTNAMES[ENVS.STAGING]) || currentHostname.includes(BIM360_HOSTNAMES[ENVS.PRODUCTION]) || currentHostname.includes(BIM360_EMEA_HOSTNAMES[ENVS.PRODUCTION]);
}
function isBIM_QA(currentHostname) {
  return currentHostname.includes(BIM360_HOSTNAMES[ENVS.QA]);
}
function isBIM_STAGING(currentHostname) {
  return currentHostname.includes(BIM360_HOSTNAMES[ENVS.STAGING]) || currentHostname.includes(BIM360_EMEA_HOSTNAMES[ENVS.STAGING]);
}
function isBIM_PRODUCTION(currentHostname) {
  return currentHostname.includes(BIM360_HOSTNAMES[ENVS.PRODUCTION]) || currentHostname.includes(BIM360_EMEA_HOSTNAMES[ENVS.PRODUCTION]);
}
function isBIM_US(currentHostname) {
  return currentHostname.includes(BIM360_HOSTNAMES[ENVS.QA]) || currentHostname.includes(BIM360_HOSTNAMES[ENVS.STAGING]) || currentHostname.includes(BIM360_HOSTNAMES[ENVS.PRODUCTION]);
}
function isBIM_EMEA(currentHostname) {
  return currentHostname.includes(BIM360_EMEA_HOSTNAMES[ENVS.PRODUCTION]) || currentHostname.includes(BIM360_EMEA_HOSTNAMES[ENVS.STAGING]);
}
function isBuildingConnected(currentHostname) {
  return currentHostname.includes(BC_HOSTNAMES[ENVS.STAGING]) || currentHostname.includes(BC_HOSTNAMES[ENVS.PRODUCTION]);
}
function isCPA(currentHostname) {
  return currentHostname.includes(CPA_HOSTNAMES[ENVS.STAGING]) || currentHostname.includes(CPA_HOSTNAMES[ENVS.PRODUCTION]);
}

/**
 * Returns one of `PLATFORMS` values based on the current hostname.
 * Fallback to `ACC` if not exist.
 */
export function getPlatformFromUrl() {
  if (isBIM(window.location.hostname)) {
    return PLATFORMS.BIM360;
  }
  return PLATFORMS.ACC;
}
let regionFromUrl;
export const getRegionFromUrl = () => {
  if (regionFromUrl) return regionFromUrl;
  const currentHostname = window.location.hostname;
  if (!currentHostname) {
    return regionFromUrl;
  }

  // BuildingConnected and CPA support US region only
  if (isBuildingConnected(currentHostname) || isCPA(currentHostname)) {
    return 'US';
  }
  const platform = getPlatformFromUrl();
  if (platform === PLATFORMS.BIM360) {
    if (isBIM_US(currentHostname)) {
      regionFromUrl = 'US';
    }
    if (isBIM_EMEA(currentHostname)) {
      regionFromUrl = 'EMEA';
      return 'EMEA';
    }
  } else {
    const {
      region
    } = parseAccUrl(currentHostname);
    regionFromUrl = region;
    return region;
  }
  return regionFromUrl;
};
export const clearRegionFromUrl = () => {
  regionFromUrl = undefined;
};
export const EnvironmentConfigSymbol = Symbol('EnvironmentConfig');
/**
 * Returns string of a region according to environment variable or detect it from URL.
 * Fallback to `US` if not exist.
 */
export const getRegion = () => {
  var _window$EnvironmentCo, _window$EnvironmentCo2;
  const fromWindow = window.REACT_APP_ACS_REGION;
  const fromEnv = getSafeRegionFromProcessEnv();
  return (_window$EnvironmentCo = (_window$EnvironmentCo2 = window[EnvironmentConfigSymbol]) === null || _window$EnvironmentCo2 === void 0 ? void 0 : _window$EnvironmentCo2.region) !== null && _window$EnvironmentCo !== void 0 ? _window$EnvironmentCo : (fromWindow || fromEnv || getRegionFromUrl() || 'US').toUpperCase();
};
let envFromUrl;
const getEnvFromUrl = () => {
  if (envFromUrl) {
    return envFromUrl;
  }
  const currentHostname = window.location.hostname;
  if (!currentHostname) {
    return envFromUrl;
  }
  if (currentHostname.includes(BC_HOSTNAMES[ENVS.STAGING]) || currentHostname.includes(CPA_HOSTNAMES[ENVS.STAGING])) {
    envFromUrl = ENVS.STAGING;
    return ENVS.STAGING;
  }
  if (currentHostname.includes(BC_HOSTNAMES[ENVS.PRODUCTION]) || currentHostname.includes(CPA_HOSTNAMES[ENVS.PRODUCTION])) {
    envFromUrl = ENVS.PRODUCTION;
    return ENVS.PRODUCTION;
  }
  const platform = getPlatformFromUrl();
  if (platform === PLATFORMS.BIM360) {
    if (isBIM_QA(currentHostname)) {
      envFromUrl = ENVS.QA;
      return ENVS.QA;
    }
    if (isBIM_STAGING(currentHostname)) {
      envFromUrl = ENVS.STAGING;
      return ENVS.STAGING;
    }
    if (isBIM_PRODUCTION(currentHostname)) {
      envFromUrl = ENVS.PRODUCTION;
      return ENVS.PRODUCTION;
    }
  } else {
    const {
      env
    } = parseAccUrl(currentHostname);
    envFromUrl = env;
    return env;
  }
  return envFromUrl;
};
export const clearEnvFromUrl = () => {
  envFromUrl = undefined;
};

/**
 * Returns one of `ENVS` values according to environment variable.
 * Fallback to `QA` if not exist.
 */
export const getEnv = () => {
  var _window$EnvironmentCo3, _window$EnvironmentCo4;
  const fromWindow = window.REACT_APP_ACS_ENV;
  const fromEnv = getSafeEnvFromProcessEnv();
  const env = (_window$EnvironmentCo3 = (_window$EnvironmentCo4 = window[EnvironmentConfigSymbol]) === null || _window$EnvironmentCo4 === void 0 ? void 0 : _window$EnvironmentCo4.env) !== null && _window$EnvironmentCo3 !== void 0 ? _window$EnvironmentCo3 : (fromWindow || fromEnv || getEnvFromUrl() || ENVS.QA).toUpperCase();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (!Object.values(ENVS).includes(env)) {
    throw Error("Unknown 'env' value: ".concat(fromEnv, ". Must be one of: ").concat(Object.values(ENVS)));
  }
  return env;
};
export const getCPAHostname = () => {
  const env = getEnv();
  return CPA_HOSTNAMES[env];
};
export const getBim360Hostname = function () {
  let {
    region
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const env = getEnv();
  const finalRegion = region || getRegion();

  // Only US and EMEA are valid regions for BIM 360
  const validRegions = ['US', 'EMEA'];
  if (!validRegions.includes(finalRegion) || env === ENVS.QA && finalRegion !== 'US') {
    throw new Error("unable to load hostname for region ".concat(finalRegion, ", env ").concat(env));
  }
  if (finalRegion === 'US') {
    return BIM360_HOSTNAMES[env];
  }
  if (finalRegion === 'EMEA') {
    return BIM360_EMEA_HOSTNAMES[env];
  }
  return BIM360_HOSTNAMES[env];
};
export function getAccHostname() {
  let {
    region
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const env = getEnv();
  const finalRegion = region || getRegion();
  const envPart = env !== ENVS.PRODUCTION ? "-".concat(env) : '';
  const regionPart = finalRegion !== 'US' ? "".concat(finalRegion, ".") : '';

  // QA should support US region only
  if (env === ENVS.QA) {
    return "acc".concat(envPart, ".autodesk.com").toLocaleLowerCase();
  }
  if (env === ENVS.STAGING && !['US', 'EMEA', 'APAC', 'AUS'].includes(finalRegion)) {
    return "acc.stg.".concat(regionPart, "autodesk.com").toLocaleLowerCase();
  }

  // EMEA has a different domain
  if (finalRegion === 'EMEA') {
    return "acc".concat(envPart, ".autodesk.eu").toLocaleLowerCase();
  }
  return "acc".concat(envPart, ".").concat(regionPart, "autodesk.com").toLocaleLowerCase();
}
export const getAccOrigin = function () {
  let {
    region
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "https://".concat(getAccHostname({
    region
  }));
};
export const getBim360Origin = function () {
  let {
    region
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "https://".concat(getBim360Hostname({
    region
  }));
};
export const getLoginUrl = () => {
  const platform = getPlatformFromUrl();
  if (platform === PLATFORMS.BIM360) {
    return "https://login.".concat(getBim360Hostname());
  }
  return "https://login.".concat(getAccHostname());
};
export const getOxygenUrl = () => OXYGEN_URL[getEnv()];
export const getUserProfileUrl = () => USER_PROFILE_URL[getEnv()];
export const getBim360AdminUrl = () => BIM360_ADMIN_URL[getEnv()];
export const getAdminApiUrl = () => ADMIN_API_URL[getEnv()];
export const getAdminConstructionApiUrl = () => ADMIN_CONSTRUCTION_API_URL[getEnv()];
export const getRelationshipServiceUrl = () => RELATIONSHIP_API_URL[getEnv()];
export const getApigeeUrl = () => APIGEE_URL[getEnv()];
export const getReportsV2Url = () => REPORTS_V2_URL[getEnv()];
export const getFormsUrl = () => FORMS_API_URL[getEnv()];
//# sourceMappingURL=config.js.map